/**
 * Validators shared by sign-in, sign-up and reset.
 *
 * - Email accepts `+` tags and hyphenated or dotted domains (fixes the
 *   Flutter app's regex, which rejected both).
 * - Password: at least 6 characters, exactly the app's rule (`^.{6,}$`) and
 *   Firebase's minimum. Never stronger than mobile's.
 * - Names: first name and family name are each required (mobile parity).
 */
const EMAIL_RE = /^[A-Za-z0-9._%+'-]+@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;

export const PASSWORD_MIN_LENGTH = 6;
export const NAME_MAX_LENGTH = 100;

export function isValidEmail(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}

export function isValidPassword(password: string): boolean {
  return password.length >= PASSWORD_MIN_LENGTH;
}

export function isValidName(name: string): boolean {
  const n = name.trim();
  return n.length > 0 && n.length <= NAME_MAX_LENGTH;
}
